"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var add_action_button_component_1 = __importDefault(require("./add-action-button.component"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var dental_template_data_1 = require("../dental-template-checkbox-tree/dental-template.data");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var AddActionButtonContainer = function AddActionButtonContainer(_ref) {
  var nodeId = _ref.nodeId,
      optionIndex = _ref.optionIndex;
  var dispatch = react_redux_1.useDispatch();
  var option = react_redux_1.useSelector(scenario_selectors_1.getSelectOption(nodeId, optionIndex));
  if (!option) throw new Error("option with given nodeId and optionIndex does not exist !!! ".concat(JSON.stringify({
    nodeId: nodeId,
    optionIndex: optionIndex
  })));

  var handleCreate = function handleCreate(type) {
    return function () {
      var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var parentOption = option;
      dispatch(scenario_actions_1.default.createNode({
        header: header || parentOption.label || parentOption.imageName || '',
        parentId: nodeId,
        optionIndex: optionIndex,
        type: type
      }));
    };
  };

  return react_1.default.createElement(add_action_button_component_1.default, {
    createTextNode: handleCreate(scenario_state_1.ScenarioNodeType.Text),
    createImageNode: handleCreate(scenario_state_1.ScenarioNodeType.Image),
    createImageExplanationNode: handleCreate(scenario_state_1.ScenarioNodeType.ImageExplanation),
    insertTemplate: function insertTemplate(template) {
      dispatch(scenario_actions_1.default.insertTempalte({
        parentNodeId: nodeId,
        parentOptionIndex: optionIndex,
        templateTopNodeId: dental_template_data_1.DENTAL_TEMPLATE_TOP_ID,
        template: template
      }));
    },
    setActionUrl: function setActionUrl(url) {
      dispatch(scenario_actions_1.default.setActionUrl({
        nodeId: nodeId,
        optionIndex: optionIndex,
        url: url
      }));
    }
  });
};

exports.default = AddActionButtonContainer;